import { render } from "./goodCause.vue?vue&type=template&id=dc49557c&scoped=true"
import script from "./goodCause.vue?vue&type=script&lang=ts"
export * from "./goodCause.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-dc49557c"

export default script